// import { registerExpressPaymentMethod } from '@woocommerce/blocks-registry';
import { registerPaymentMethod } from "@woocommerce/blocks-registry";
import { createElement, useEffect, Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import MethodDescription from "./selectPart"; // Импортируем новый компонент
import "./styles.scss";

// Получаем функцию для регистрации платёжного метода.
document.addEventListener("DOMContentLoaded", function () {
  // const config = saphaliSettingsPrivatBank;
  const data = {
    ...window.wc.wcSettings.getSetting("privat_join_data"),
    partforclient:
    saphaliSettingsPrivatBank.partforclient,
    partsCount: parseInt(saphaliSettingsPrivatBank.partsCount),
    partsCountName: saphaliSettingsPrivatBank.partsCountName || [],
    merchantTypeName: saphaliSettingsPrivatBank.merchantTypeName || [],
  };
  const PaymentMethodContent = (props) => {
    const { billing } = props;
    // console.log("MonoPaymentMethodContent", props);

    return (
      <MethodDescription
        billing={billing}
        data={data}
        eventRegistration={props.eventRegistration}
        emitResponse={props.emitResponse}
      />
    );
  };

  /**
   * Компонент, отвечающий за вывод ярлыка (label) платежного метода.
   */
  const PaymentMethodLabel = () => {
    return <div className="privat-payment-method-label">{data.title}</div>;
    //   createElement(
    //     "div",
    //     { className: "privat-payment-method-label" },
    //     data.title
    //   )
  };

  /**
   * Компонент для отображения в редакторе (админском интерфейсе блока).
   * Он позволяет показать предпросмотр для мерчанта.
   */
  const PaymentMethodEdit = () => {
    return createElement(
      "div",
      { className: "privat-payment-method-edit" },
      "PrivatBank (редактирование)"
    );
  };

  /**
   * Функция, определяющая, доступен ли данный платёжный метод для покупателя.
   * Здесь можно добавить любые проверки (например, по составу корзины или странам доставки).
   * Для простоты в примере всегда возвращаем true.
   */
  const canMakePayment = () => {
    return true;
  };

  /**
   * Конфигурация платежного метода для клиентской стороны.
   * Обратите внимание, что:
   * - name и paymentMethodId должны совпадать и быть уникальными.
   * - gatewayId – идентификатор платежного шлюза, зарегистрированного на сервере.
   * - label, content, edit – React-элементы (созданные через wp.element.createElement или JSX, если у вас настроен сборщик).
   */
  const monoPaymentMethodOptions = {
    name: "privat_join",
    title: data.title,
    description: data.description,
    gatewayId: "privat_join", // идентификатор, который должен быть зарегистрирован на серверной стороне
    label: createElement(PaymentMethodLabel),
    ariaLabel: __("Оплатить через PrivatBank", "themewoocommerce-pr_join"),
    content: createElement(PaymentMethodContent),
    placeOrderButtonLabel: __(
      "Оформить оплату частями через PrivatBank",
      "themewoocommerce-pr_join"
    ),
    edit: createElement(PaymentMethodEdit),
    canMakePayment,
    paymentMethodId: "privat_join",
    supports: {
      features: ["products"], // можно добавить другие возможности, если требуется
      style: ["height", "borderRadius"],
    },
  };

  // Регистрируем express-платёжный метод.
  // registerExpressPaymentMethod( monoPaymentMethodOptions );
  registerPaymentMethod(monoPaymentMethodOptions);

  // Если требуется регистрация обычного платежного метода (не express),
  // то можно использовать registerPaymentMethod, например:
  // const { registerPaymentMethod } = wc.wcBlocksRegistry;
  // registerPaymentMethod( monoPaymentMethodOptions );
});
